import React from "react";

export const MainContext = React.createContext (null);
export const MasterContext = React.createContext (null);

